import api from "@/api";

export default {
    namespaced: true,
    state: () => ({
      classes: [],
      currentClass: null,
      isLoading: false,
      error: null,
      pagination: {
        currentPage: 1,
        totalPages: 1,
        totalItems: 0,
        perPage: 10,
        from: 0,
        to: 0
      }
    }),
    mutations: {
      SET_CLASSES(state, classes) {
        state.classes = classes;
      },
      SET_CURRENT_CLASS(state, classItem) {
        state.currentClass = classItem;
      },
      SET_LOADING(state, isLoading) {
        state.isLoading = isLoading;
      },
      SET_ERROR(state, error) {
        state.error = error;
      },
      SET_PAGINATION(state, { currentPage, totalPages, totalItems, perPage, from, to }) {
    state.pagination = {
      currentPage,
      totalPages,
      totalItems,
      perPage,
      from,
      to
    };
  },
      ADD_CLASS(state, newClass) {
        state.classes.unshift(newClass);
      },
      UPDATE_CLASS(state, updatedClass) {
        const index = state.classes.findIndex(c => c.id === updatedClass.id);
        if (index !== -1) {
          state.classes.splice(index, 1, updatedClass);
        }
      },
      DELETE_CLASS(state, classId) {
        state.classes = state.classes.filter(c => c.id !== classId);
      },
      RESET_CURRENT_CLASS(state) {
        state.currentClass = null;
      }
    },
    actions: {
   
      async fetchClasses({ commit }, { page = 1, per_page = 10, search = '' } = {}) {
        try {
          commit('SET_LOADING', true);
          const response = await api.get('/classes', {
            params: { page, per_page, search }
          });
          
          const responseData = response.data?.data || [];
          const meta = response.data?.meta || {
            current_page: page,
            last_page: 1,
            total: responseData.length,
            per_page,
            from: (page - 1) * per_page + 1,
            to: Math.min(page * per_page, responseData.length)
          
          };
      
          commit('SET_CLASSES', responseData);
          commit('SET_PAGINATION', {
            currentPage: meta.current_page,
            totalPages: meta.last_page,
            totalItems: meta.total,
            perPage: meta.per_page,
            from: meta.from,
            to: meta.to
          });
          
        } catch (error) {
          commit('SET_ERROR', error.response?.data?.message || error.message);
          throw error;
        } finally {
          commit('SET_LOADING', false);
        }
      },
      async fetchClass({ commit }, classId) {
        try {
          commit('SET_LOADING', true);
          const response = await api.get(`/classes/${classId}`);
          return response.data;
        } catch (error) {
          commit('SET_ERROR', error.response?.data?.message || error.message);
          throw error;
        } finally {
          commit('SET_LOADING', false);
        }
      },
  
      async createClass({ commit }, classData) {
        try {
          commit('SET_LOADING', true);
          const response = await api.post('classes', classData);
          commit('ADD_CLASS', response.data);
          return response.data;
        } catch (error) {
          commit('SET_ERROR', error.response?.data?.message || error.message);
          throw error;
        } finally {
          commit('SET_LOADING', false);
        }
      },
  
      async updateClass({ commit }, { classId, classData }) {
        try {
          commit('SET_LOADING', true);
          const response = await api.put(`/classes/${classId}`, classData);
          commit('UPDATE_CLASS', response.data);
          commit('SET_CURRENT_CLASS', response.data);
          return response.data;
        } catch (error) {
          commit('SET_ERROR', error.response?.data?.message || error.message);
          throw error;
        } finally {
          commit('SET_LOADING', false);
        }
      },
  
      async deleteClass({ commit }, classId) {
        try {
          commit('SET_LOADING', true);
          await api.delete(`classes/${classId}`);
          commit('DELETE_CLASS', classId);
          commit('RESET_CURRENT_CLASS');
        } catch (error) {
          commit('SET_ERROR', error.response?.data?.message || error.message);
          throw error;
        } finally {
          commit('SET_LOADING', false);
        }
      },
  
      clearError({ commit }) {
        commit('SET_ERROR', null);
      }
    },
    getters: {
      getClasses: state => state.classes,
      getClassById: state => id => state.classes.find(c => c.id === id),
      getCurrentClass: state => state.currentClass,
      isLoading: state => state.isLoading,
      getError: state => state.error,
      getPagination: state => state.pagination,
      activeClasses: state => state.classes.filter(c => c.is_active),
      archivedClasses: state => state.classes.filter(c => !c.is_active)
    }
  }